import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import { EkoElement } from "@/utilities/element";
import style from "./secondary-nav-current.css?inline";

@customElement("eko-secondary-nav-current")
class NavigationCurrent extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  private handleClick() {
    this.dispatchEvent(new CustomEvent("shell:current:click", { bubbles: true }));
  }

  private renderIcon() {
    return html`<span class="eko-secondary-nav-current__icon">
      <eko-icon name="chevron-left"></eko-icon>
    </span>`;
  }

  render() {
    return html`<button class="eko-secondary-nav-current" @click=${this.handleClick}>
      ${this.renderIcon()}
      <span class="eko-secondary-nav-current__label">
        <slot></slot>
      </span>
    </button>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-secondary-nav-current": NavigationCurrent;
  }
}

export default NavigationCurrent;
